import type { FaireProductEntity } from "../../entity_types/product";

export const p_8brbnqk6eb: FaireProductEntity = {
  token: "p_8brbnqk6eb",
  type: "product",
  name: "Come and Behold Him",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/2ffc8059c3bdc8e5e831056c626fa80e79c412e12cfbe1333e5191985d450d56.jpeg",
  galleryImageUrls: [],
  priceDollars: 13.5,
  description: "This beautiful, full-color Advent devotional from #1 New York Times bestselling author Joyce Meyer and Ginger Stache invites you to savor the joy of the season. Long ago, on a silent night in Bethlehem, a Child came into the world who would change it forever. It was the advent of a new age—the arrival of a Savior for us all—and we celebrate Him and His birth each year at Christmas. Or do we? We certainly celebrate. We gather together, put up lights, give gifts—all wonderful traditions that make Christmastime special—but do we take the time to give Him the honor He deserves? And could we be missing some of the wonder He came to bring us? In their first-ever Christmas devotional, Joyce and Ginger will help you re-center around what’s truly important this Christmas. Each devotion contains: A Scripture reading to focus on what really matters, a comforting reflection from Joyce and Ginger, a prayer to our loving Father so you can begin to receive His promises, a prompt to help you respond and apply what you’re hearing directly to your life this season, and gorgeous watercolor illustrations with each devotion. When we build our Christmas season around the right things, everything changes. Experience the peace and wonder of Christmas in a new way with Come and Behold Him!",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:07:07.945Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
